import { defineMessages } from 'react-intl'

export default defineMessages({
  createMemory: {
    id: 'containers.MemoryBankPage.createMemory',
    defaultMessage: 'Create memory',
  },
  downloadAudio: {
    id: 'containers.MemoryBankPage.downloadAudio',
    defaultMessage: 'Download audio',
  },
  duplicate: {
    id: 'containers.MemoryBankPage.duplicate',
    defaultMessage: 'Duplicate',
  },
  delete: {
    id: 'containers.MemoryBankPage.delete',
    defaultMessage: 'Delete',
  },
  columnText: {
    id: 'containers.MemoryBankPage.columnText',
    defaultMessage: 'Text',
  },
  columnLanguage: {
    id: 'containers.MemoryBankPage.columnLanguage',
    defaultMessage: 'Language',
  },
  columnRecorded: {
    id: 'containers.MemoryBankPage.columnRecorded',
    defaultMessage: 'Status',
  },
  columnAudio: {
    id: 'containers.MemoryBankPage.columnAudio',
    defaultMessage: 'Audio',
  },
  recorded: {
    id: 'containers.MemoryBankPage.recorded',
    defaultMessage: 'Recorded',
  },
  modalDefaultTitle: {
    id: 'containers.MemoryBankPage.modalDefaultTitle',
    defaultMessage: 'Memory',
  },
})
